export function isNumber(value) {
    if (!value) {
        return false;
    }
    return /^\d*$/.test(value);
}